import { AngularFirestore } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { DataAccessHelpersService } from "./data-access-helpers.service";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from "../../../environments/environment";
import { timeout, take } from 'rxjs/operators';



@Injectable({
  providedIn: "root",
})
export class ClientAccessService {

   API_ENDPOINT = environment.API_ENDPOINT;
   headers = { "Content-Type": "application/json" };


   getIdToken() {
    return this.afAuth.auth.currentUser.getIdToken(true);
  }
  /**
   * Returns Client data by id
   * @param parc Parc Id
   * @param clientId Client Id
   */
  getClientData(parc: string, clientId: string): Promise<IClient> {
    return this.dhs.getDocumentOnce(`yards/${parc}/clients/${clientId}`);
  }
  /**
   * Returns all clients belongs to a parc
   * @param parc Parc Id
   */
  getAllClients(parc: string): Promise<IClient[]> {
    return this.dhs.getCollectionOnce(`yards/${parc}/clients`);
  }

  /**
   * Récupérer les clients WorkShop Contract sans Consumable
   */
getClientsWCfirebase(parcId: string): Promise<Array<{ id: string }>> {
  return this.dhs.getCollectionOnce(`yards/${parcId}/clients`);
}
   getClientsWC(parc: string): Promise<Array<{ id: string }>> {
    return this.getIdToken()
    .then((idToken) => {
      return fetch(`${this.API_ENDPOINT}/getClientsWC`, {
        headers: { 
          ...this.headers, 
          Authorization: idToken,
          'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify({ parc }),
      });
    })
    .then(res => {
      if (!res.ok) {
        throw new Error('Erreur API getClientsWC');
      }
      return res.json();
    })
    .then((data: string[]) => {
      // 🔥 transformation string[] -> {id: string}[]
      return data.map(id => ({ id }));
    });
}

  /**
   * Returns all suppliers belongs to a parc
   * @param parc Parc Id
   */
  getAllFournisseurs(parc: string): Promise<IFournisseur[]> {
    return this.dhs.getCollectionOnce(`yards/${parc}/fournisseurs`);
  }

   
  getAllLiners(): Promise<string[]> {
    return this.dhs.getDocumentOnce(`constants/AllLiners`).then((data: any) => {

      const liners = data && data.liners ? data.liners : [];

      return liners;
    });
    
  }


 
  createLiner(liner: string): Promise<void> {
  const docRef = this.afs
    .collection("constants")
    .doc("AllLiners");

  return docRef.ref.get().then(doc => {

    let liners: string[] = [];

    if (doc.exists) {
      const data = doc.data();

      if (data && data["liners"]) {
        liners = data["liners"];
      }
    }

    if (liners.indexOf(liner) === -1) {
      liners.push(liner);
    }

    return docRef.set({
      liners: liners
    });
  });
}
  
  updateClient(parcId: string, clientId: string, data: Partial<IClient>) {
    return this.afs
      .collection("yards")
      .doc(parcId)
      .collection("clients")
      .doc(clientId)
      .update(data);
  }
  /**
   * Returns all trucking suppliers belongs to a parc
   * @param parc Parc Id
   */
  getTruckingFournisseur(parc: string): Observable<IFournisseur[]> {
    return this.dhs.getCollectionWhere(`yards/${parc}/fournisseurs`, [
      { left: "activity", operator: "==", right: "Transporter" },
    ]);
  }
  /**
   * Get Shunting contract of a client
   * @param parc  Parc Id
   * @param client Client Id
   */
  getClientShuntingBilling(
    parc: string,
    client: string
  ): Promise<IShuntingContract> {
    return this.dhs.getDocumentOnce(
      `yards/${parc}/clients/${client}/depotcontracts/shuntingContract`
    );
  }
  constructor(
    private dhs: DataAccessHelpersService,
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth
  ) {}
}
